export default "__VITE_ASSET__UalFryUd__"